/**
 * Seasonal Data Types for v2v2 SWFL Farmers Market Application
 * Defines the structure for Southwest Florida seasonal produce data
 */

export interface SeasonalProduce {
  name: string;
  season: string;
  peak: string;
  description: string;
  uPickLocations?: string[];
}

export interface MonthAvailability {
  peak: string[];
  available: string[];
  limited: string[];
  highlights: string;
  farmersMarketTips: string;
}

export interface ProduceByCategory {
  [category: string]: SeasonalProduce[];
}

export interface SeasonalData {
  currentMonth: Month;
  months: { [month: string]: MonthAvailability };
  produceByCategory: ProduceByCategory;
  shoppingTips: { tip: string; description: string }[];
  whereToShop: {
    farmersMarkets: string[];
    uPickFarms: string[];
    farmStands: string[];
  };
}

export type AvailabilityStatus = 'peak' | 'available' | 'limited' | 'year-round';

export interface ProduceAvailability {
  name: string;
  status: AvailabilityStatus;
  season?: string;
  peak?: string;
  uPickLocations?: string[];
  description?: string;
}

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const;

export type Month = typeof MONTHS[number];

export const SEASONS = {
  spring: ['March', 'April', 'May'],
  summer: ['June', 'July', 'August'],
  fall: ['September', 'October', 'November'],
  winter: ['December', 'January', 'February'],
} as const;

export type Season = keyof typeof SEASONS;

export const SEASON_LABELS: Record<Season, string> = {
  spring: 'Spring',
  summer: 'Summer',
  fall: 'Fall',
  winter: 'Winter',
};
